import ApiMethod from './ApiMethod';
import { BASE_URL } from './enum/ApiPath';

const { hostname } = window.location;
const isDev = hostname === 'localhost' || hostname === 'dev.tickets.leisureq.io';
const lqApi = isDev ? new ApiMethod(BASE_URL.DEV) : new ApiMethod(BASE_URL.PRODUCTION);

export default lqApi;


// WEBPACK FOOTER //
// ./src/api/index.js